import { useHistory } from "react-router-dom";
import { baseURL } from "../../../basics";
import ShowPriceInCardItem from "./ShowPriceInCardItem";
import LikeAndUnLikeButton from "../../Ui/LikeAndUnLikeButton";
import UnitTypeBox from "../../Ui/UnitTypeBox";
import GradeDescription from "../../Ui/GradeDescription";
import CheckStockAndChangeButton from "../../Ui/CheckStockAndChangeButton";
import { useEffect, useState } from "react";

const SpecialItem = (props: any) => {
  const {
    id,
    title,
    price,
    imageUrl,
    discountedPrice,
    unit,
    unitType,
    grade,
  } = props.items;

  const history = useHistory();
  const sendUserToProductItemPage = () => {
    history.push(`/products/productItem/${id}`);
  };
  const [truncatedText, settRuncatedText] = useState("");
  useEffect(() => {
    if (title) {
      const rangeStart = 0;
      const rangeEnd = 20;
      const lastWordBoundary = title.lastIndexOf(" ", rangeEnd);
      const truncatedText =
        lastWordBoundary >= rangeEnd
          ? `${title.substring(rangeStart, lastWordBoundary)} ...`
          : `${title.substring(rangeStart, rangeEnd)}`;
      settRuncatedText(truncatedText);
    }
  }, [title]);

  return (
    <div className="relative">
      <form
        className="bg-white border border-slate-100 rounded-2xl shadow-sm m-1 relative w-full min-h-[190px] flex flex-col justify-between p-3"
        style={{ background: props.colorCode }}
      >
        <LikeAndUnLikeButton item={props.items} />

        <div
          onClick={sendUserToProductItemPage}
          className="flex justify-between items-start gap-3 cursor-pointer"
        >
          <img
            src={`${baseURL}${imageUrl}`}
            alt={title}
            className="h-24 w-24 sm:h-28 sm:w-28 object-contain rounded-xl bg-white/80 p-1 shrink-0"
          />

          <div className="flex-1 min-w-0 flex flex-col gap-2 pt-1">
            <div>
              <p className="text-base sm:text-lg font-bold text-gray-900 truncate">
                {truncatedText}
              </p>
              <GradeDescription grade={grade} color={"gray"} align="right" />
            </div>
            <div className="flex flex-col items-start gap-1">
              <UnitTypeBox unit={unit} unitType={unitType} large />
              <ShowPriceInCardItem
                price={price}
                discountedPrice={discountedPrice}
                large
              />
            </div>
          </div>
        </div>

        <div className="pt-3">
          <CheckStockAndChangeButton
            parentStyles={"w-full"}
            childStyles={"bg-emerald-600 hover:bg-emerald-700 shadow-sm"}
            items={props.items}
            large
            showLabel
          />
        </div>
      </form>
    </div>
  );
};
export default SpecialItem;
